import React, { useState, useEffect, useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "../../utils/api";
import moment from "moment";
import {
  getStationName,
  getPlanSelectionName,
  getPlanStaionBundle,
  // getParkingSlot,
  addDriverBundleSubscription,
  getBundleDayReference,
  getDayReferenceChargingSiteBundle,
  getDayshareParkingSlot,
  apiEndpointFailed,
  addDriverBundleSubscriptionWithNoParking,
} from "../../actions/commonActions";
import Switch from "../Switch";
import { Modal, Button } from "react-bootstrap";
import { setPageTitle } from "../../utils/helper";
import Loading from "../Shared/Loading";
import "./PlanSelection.css";

const MOMENT_FORMAT = "YYYY-MM-DD";
const { REACT_APP_API_URL } = process.env;

const reducer = (state, { field, value }) => {
  return {
    ...state,
    [field]: value,
  };
};

let initialState = {
  stationName_id: "",
  plan: "",
  ev_charging_site_bundle_id: "",
  parking_slot_id: "",
  day_reference_code: "",
  day_reference_charging_site_bundle: "",
};

const PlanSelection = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [planSelected, setPlanSelected] = useState(false);
  const [bothShare, setBothShare] = useState(false);
  const [daysShare, setDaysShare] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [anytimeParkSlots, setAnytimeParkSlots] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [object, setObject] = useState(null);
  const [dayBundles, setDayBundles] = useState([]);
  const [chargingSlots, setChargingSlots] = useState([[]]);
  const [isLoading, setIsLoading] = useState(false);
  // const [daySelected, setDaySelected] = useState(null);

  const {
    stationNameList,
    planSelectionNameList,
    planStationBundleList,
    parkingSlotsList,
    DriverBundleSubscriptionCreationStatus,
    bundleDayReferenceList,
    dayReferenceChargingSiteBundleList,
    // dayShareParkingSlotsList,
    apiEndPointFailed,
    evChargingSiteId,
    driverChargingSites,
  } = useSelector((reduxState) => reduxState.common);

  const [state, setState] = useReducer(reducer, initialState);

  const [ev_charging_site_id, setEvChargingSiteId] = useState(evChargingSiteId);
  const [driver_id, setDriver_id] = useState("");
  const [ChargingSiteBundleInfo, setChargingSiteBundleInfo] = useState({
    bundleFixedPriceCharged: "",
    currency: "",
    description: "",
  });
  // modal display state
  // const [modalStatus, setModalStatus] = useState(false);
  const [stationInactiveModal, setstationInactiveModal] = useState(false);

  const [submitPlan, setSubmitPlan] = useState(false);
  const [congratulationScreen, setCongratulationScreen] = useState(false);
  useEffect(() => {
    // DriverBundleSubscriptionCreationStatus && history.push("/home");
    DriverBundleSubscriptionCreationStatus && setCongratulationScreen(true);
    console.log("driver_bundle_subscription", state);
    // alert("no")
  }, [DriverBundleSubscriptionCreationStatus]);
  console.log("driver_bundle_subscriptionState", bundleDayReferenceList);

  useEffect(() => {
    setEvChargingSiteId(evChargingSiteId);
    getStationName(dispatch, evChargingSiteId);
  }, [evChargingSiteId]);

  useEffect(() => {
    setDriver_id(localStorage.getItem("driver_id"));
    getStationName(dispatch, evChargingSiteId);
    getPlanSelectionName(dispatch);
    setEvChargingSiteId(evChargingSiteId);
    // setModalStatus(apiEndPointFailed.isApiEndPointFailed);
    setPageTitle("Plan Selection");
  }, []);

  //bring Charging_site_bundle when bundle type is changed
  useEffect(() => {
    if (state.plan) {
      if (state.plan === "DAYSH") {
        getBundleDayReference(dispatch);
      } else {
        getPlanStaionBundle(dispatch, state.plan, ev_charging_site_id);
      }
      // state.plan != "DAYSH" &&
      //   getPlanStaionBundle(dispatch, state.plan, ev_charging_site_id);
      // state.plan == "DAYSH" && getBundleDayReference(dispatch);
      setState({ field: "ev_charging_site_bundle_id", value: "" });
      setState({ field: "day_Reference", value: "" });
    }
  }, [state.plan]);

  // gets parking slots when charging site bundle is selected
  useEffect(() => {
    if (state.ev_charging_site_bundle_id) {
      if (state.plan == "ANYT") {
        getDayshareParkingSlot(dispatch, {
          ev_charging_site_id: ev_charging_site_id,
          ev_charging_site_bundle_id: state.ev_charging_site_bundle_id,
          day_of_the_week: -1,
        });
      }

      setState({ field: "parking_slot_id", value: "" });
      let chargingBundle = planStationBundleList.filter((stationBundle) => {
        return (
          stationBundle.ev_charging_site_bundle_id ==
          state.ev_charging_site_bundle_id
        );
      });
      setChargingSiteBundleInfo({
        ...ChargingSiteBundleInfo,
        bundleFixedPriceCharged: chargingBundle[0].price,
        currency:
          (chargingBundle[0].currency && chargingBundle[0].currency.name) ||
          chargingBundle[0].currency_code,
      });
    }
  }, [state.ev_charging_site_bundle_id]);
  console.log("selectedPlan", selectedPlan);
  useEffect(() => {
    if (parkingSlotsList.length > 0) {
      const { parking_slot_id } = parkingSlotsList[0];
      setState({
        field: "parking_slot_id",
        value: parking_slot_id,
      });
    }
  }, [parkingSlotsList]);

  useEffect(() => {
    if (stationNameList.length > 0) {
      setState({
        field: "stationName_id",
        value: stationNameList[0].ev_charging_site_id,
      });
      setChargingSiteBundleInfo({
        ...ChargingSiteBundleInfo,
        description: stationNameList[0].description,
      });
    }
  }, [stationNameList]);
  console.log("planStationBundleList", planStationBundleList[0]?.hasBundle);
  useEffect(() => {
    if (planStationBundleList.length > 0) {
      setState({
        field: "ev_charging_site_bundle_id",
        value: planStationBundleList[0].ev_charging_site_bundle_id,
      });
    }
    console.log("hmmm", planStationBundleList);
  }, [planStationBundleList]);

  //brings charging site bundles by (day_code) when bundleSubscription day share is selected
  useEffect(() => {
    if (state.day_reference_code) {
      getDayReferenceChargingSiteBundle(
        dispatch,
        state.day_reference_code,
        ev_charging_site_id
      );
    }
  }, [state.day_reference_code]);

  useEffect(() => {
    if (dayReferenceChargingSiteBundleList.length > 0) {
      setState({
        field: "day_reference_charging_site_bundle",
        value: dayReferenceChargingSiteBundleList[0].ev_charging_site_bundle_id,
      });
      console.log(
        "Ahmadplztest",
        dayReferenceChargingSiteBundleList[0].ev_charging_site_bundle_id
      );
    }
  }, [dayReferenceChargingSiteBundleList]);

  useEffect(() => {
    if (dayReferenceChargingSiteBundleList.length > 0) {
      let selectedDay = bundleDayReferenceList.filter((dayBundle) => {
        return dayBundle.day_code == state.day_reference_code;
      });
      console.log("selectedDay", selectedPlan);
      if (selectedPlan?.bundle_subscription_type_code === "DAYSH") {
        getDayshareParkingSlot(dispatch, {
          ev_charging_site_id: ev_charging_site_id,
          ev_charging_site_bundle_id: state.day_reference_charging_site_bundle,
          day_of_the_week:
            state.day_reference_code == "EVD"
              ? -1
              : selectedDay[0]?.day_of_the_week,
        });
      }
    }
  }, [state.day_reference_charging_site_bundle]);

  useEffect(() => {
    bundleDayReferenceList.map((dayBundle) => {
      let payload = {
        ev_charging_site_id: ev_charging_site_id,
        ev_charging_site_bundle_id: state.day_reference_charging_site_bundle,
        day_of_the_week:
          state.day_reference_code == "EVD" ? -1 : dayBundle.day_of_the_week,
      };
      axios
        .get(
          `${REACT_APP_API_URL}/ev_charging_site_bundles/ev_charging_site_id/${ev_charging_site_id}/DAYCODE/${
            state.day_reference_code == "EVD" ? -1 : dayBundle.day_code
          }`
        )
        .then(({ data }) => {
          console.log(`data for day bundle list for`, {
            data,
          });
          // if(data?.response?.evChargingSiteBundles[0].length>0)
          // {
          setDayBundles((prevState) => [
            ...prevState,
            {
              day: data?.response.evChargingSiteBundles[0]?.name
                .replaceAll(" ", "")
                .replace("SHARE", ""),
              price: data?.response?.evChargingSiteBundles[0]?.price,
              currency: data?.response?.evChargingSiteBundles[0]?.currency_code,
              bundle_id:
                data?.response?.evChargingSiteBundles[0]
                  ?.ev_charging_site_bundle_id,
              week_day:
                data?.response?.evChargingSiteBundles[0]
                  ?.bundle_subscription_type_code == "ANYT"
                  ? -1
                  : dayBundle.day_of_the_week,
              day_code: state.day_reference_code,
            },
          ]);
          // }
        })
        .catch((err) => {
          console.log(err);
        });

      // axios
      //   .post(`${REACT_APP_API_URL}/find_parking_slots`, payload)
      //   .then(({ data }) => {
      //     console.log(`data for parking slot ${dayBundle.day_of_the_week}`, { data })
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

      // console.log(`payload to check for ${dayBundle.day_of_the_week}`, payload)
    });
  }, [bundleDayReferenceList]);
  console.log("bundleDayReferenceList", dayReferenceChargingSiteBundleList);
  useEffect(() => {
    if (dayBundles.length > 7) {
      dayBundles.map((bundle) => {
        let payload = {
          ev_charging_site_id: ev_charging_site_id,
          ev_charging_site_bundle_id: bundle.bundle_id,
          day_of_the_week: bundle.week_day,
        };
        axios
          .post(`${REACT_APP_API_URL}/find_parking_slots`, payload)
          .then(({ data }) => {
            console.log(`data parking slots for ${bundle.day}`, { data });
            setChargingSlots((prevState) => [
              ...prevState,
              {
                day: bundle.day === "anytime" ? "Every Day" : bundle.day,
                parkingSlots: data.response.parkingSlots,
              },
            ]);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }
  }, [dayBundles]);

  useEffect(() => {
    // https://api.elutag.com/ev_charging_site_bundles/ANYT/ev_charging_site_id/48

    // let bundleTypeCode = "ANYT";
    axios
      .get(
        `${REACT_APP_API_URL}/ev_charging_site_bundles/ANYT/ev_charging_site_id/${evChargingSiteId}/driver/${localStorage.getItem(
          "driver_id"
        )}`
      )
      .then(({ data }) => {
        console.log(`data bundle for Anytime`, { data });

        let evCsBundleId =
          data.response.evChargingSiteBundles[0].ev_charging_site_bundle_id;

        let payload = {
          ev_charging_site_id: evChargingSiteId,
          ev_charging_site_bundle_id: evCsBundleId,
          day_of_the_week: -1,
        };

        axios
          .post(`${REACT_APP_API_URL}/find_parking_slots`, payload)
          .then(({ data }) => {
            console.log("parkingslots for anytime", data);
            if (data.response.parkingSlots.length < 1) {
              setAnytimeParkSlots(true);
              // setPlanSelected(false);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [planSelectionNameList]);

  console.log("day bundles", dayBundles);
  console.log("parking slots", chargingSlots);
  console.log("selected plan", selectedPlan);

  useEffect(() => {
    // setModalStatus(apiEndPointFailed.isApiEndPointFailed);
  }, [apiEndPointFailed]);

  // const selectChangeHandler = (obj) => {
  //   // setState({ field: e.target.name, value: e.target.value });

  //   console.log("filed and value :", obj)

  //   handleSavePlan(obj)
  //   // setState({
  //   //   field: e.target.name,
  //   //   value: e.target.value,
  //   //  });
  // };

  const handleSavePlan = () => {
    if (object) {
      setState(object);
      setPlanSelected(true);
    } else {
      alert("PLEASE SELECT PLAN FIRST");
    }
  };
  function formatPrice(price) {
    return price?.toFixed(2);
  }

  const switchChangeHandlerDayShare = (e) => {
    // setDaySelected({
    //   field: "day_reference_code",
    //   value: e.target.id,

    // })
    setState({
      field: "day_reference_code",
      value: e.target.id,
    });
    // setState({
    //   field: "day_reference_code_ui",
    //   value: true,
    // });
  };

  // const confirmDayHandler = () => {
  //   if (daySelected) {
  //     setState(daySelected);
  //     setState({
  //       field: "day_reference_code_ui",
  //       value: true,
  //     });
  //   }
  // }

  const onParkingSlotChecked = (e) => {
    setState({ field: "parking_slot_id", value: e.target.id });
  };

  const submitDriverBundleSubscriptionHandler = (e) => {
    e.preventDefault();
    if (
      // selectedPlan?.bundle_subscription_type_code === "FLEX" ||
      daysShare === false
    )
      return;
    setSubmitPlan(true);
    // Get Selected Station
    let stationActive = driverChargingSites.filter(
      (site) => site.ev_charging_site_id == ev_charging_site_id
    );
    // Is selected station active?
    stationActive = stationActive[0] && stationActive[0].is_active_flag;

    setstationInactiveModal(!stationActive);

    if (stationActive) {
      if (state.plan == "ONET") {
        addDriverBundleSubscription(dispatch, {
          driver_id,
          ev_charging_site_bundle_id: state.ev_charging_site_bundle_id,
          auto_renewal_flag: 0,
          start_date_time: moment().format(MOMENT_FORMAT),
        });
      } else {
        addDriverBundleSubscription(
          dispatch,
          {
            driver_id,
            ev_charging_site_bundle_id:
              state.plan == "DAYSH"
                ? state.day_reference_charging_site_bundle
                : state.ev_charging_site_bundle_id,
            parking_slot_id: state.parking_slot_id,
            auto_renewal_flag: null,
            start_date_time: null,
          },
          setSubmitPlan
        );
      }
    }
  };

  console.log("VALUE CHECK FOR PLAN SELECTION: ", {
    stationNameList,
    planSelectionNameList,
    planStationBundleList,
    parkingSlotsList,
    DriverBundleSubscriptionCreationStatus,
    bundleDayReferenceList,
    dayReferenceChargingSiteBundleList,
    apiEndPointFailed,
    evChargingSiteId,
    driverChargingSites,
    ChargingSiteBundleInfo,
  });

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3500);
  }, [isLoading]);

  useEffect(() => {
    setTimeout(() => {
      setPageLoading(false);
    }, 3500);
  }, [pageLoading]);
  console.log("parkingSlotsList", parkingSlotsList);
  const renderButton = () => {
    if (state.plan) {
      if (state.plan === "FLEX") {
        return (
          <>
            {bothShare ? (
              planStationBundleList[0]?.hasBundle ? (
                <p
                  style={{
                    color: "darkred",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  You already have purchased this bundle
                </p>
              ) : (
                <button
                  onClick={() => {
                    // setBothShare(false);
                    setIsLoading(true);
                    let payload = {
                      driver_id,
                      ev_charging_site_bundle_id:
                        state.ev_charging_site_bundle_id,
                      auto_renewal_flag: null,
                      start_date_time: null,
                    };
                    if (state.plan === "FLEX") {
                      addDriverBundleSubscriptionWithNoParking(
                        payload,
                        setCongratulationScreen,
                        setSubmitPlan
                      );
                    }
                    //setCongratulationScreen(true);
                  }}
                  className="button btn btn-primary form-control color mt-2 btn_white "
                >
                  {" "}
                  {"Buy"}
                </button>
              )
            ) : (
              <button
                className="button btn btn-primary form-control color mt-2 btn_white "
                type="submit"
                disabled={submitPlan || parkingSlotsList.length < 1}
              >
                {submitPlan ? <Loading style={{ height: "30px" }} /> : "Buy"}
              </button>
            )}
          </>
        );
      } else if (state.plan === "DAYSH" || state.plan === "ANYT") {
        return (
          <>
            {!bothShare ? (
              <button
                onClick={() => setBothShare(true)}
                className="button btn btn-primary form-control color mt-2 btn_white "
                disabled={submitPlan || parkingSlotsList.length < 1}
              >
                {" "}
                Continue
              </button>
            ) : (
              <button
                onClick={() => setDaysShare(true)}
                className="button btn btn-primary mt-2 btn_white"
                type="submit"
                disabled={submitPlan || parkingSlotsList.length < 1}
              >
                {submitPlan ? <Loading style={{ height: "30px" }} /> : "Buy"}
              </button>
            )}
          </>
        );
      }
      // else if (state.plan === "DAYSH") {
      //   return (<button
      //     className="button btn btn-primary mt-2 "
      //     type="button"
      //     onClick={() => confirmDayHandler()}
      //   // disabled={submitPlan || parkingSlotsList.length < 1}
      //   >

      //     confirm
      //   </button>)
      // }
    }
    return (
      <button
        className="button btn btn-primary  mt-2 btn_white "
        // disabled={submitPlan || parkingSlotsList.length < 1}

        onClick={() => {
          console.log(
            "selectedPlan?.bundle_subscription_type_code",
            selectedPlan?.bundle_subscription_type_code
          );
          // Call handleSavePlan and setIsLoading
          handleSavePlan();
          setIsLoading(true);

          // Check if bundle_subscription_type_code is "FLEX" or "ANYT"
          if (
            selectedPlan?.bundle_subscription_type_code === "FLEX" ||
            selectedPlan?.bundle_subscription_type_code === "ANYT"
          ) {
            // If true, setBothShare to true
            if (selectedPlan?.bundle_subscription_type_code === "FLEX") {
              setBothShare(true);
            }

            // Call getDayReferenceChargingSiteBundle
            getDayReferenceChargingSiteBundle(
              dispatch,
              false,
              ev_charging_site_id,
              selectedPlan?.bundle_subscription_type_code
            );
          } else {
            // If bundle_subscription_type_code is not "FLEX" or "ANYT", do something else
            // You may want to add an else condition to handle other cases
          }

          // setSelectedPlan(null) - This line is commented out, not sure if you want to execute it
        }}
      >
        Select Plan
      </button>
    );
  };

  return (
    <div className="container parentDiv">
      {!pageLoading ? (
        <form
          className="text-center form"
          onSubmit={submitDriverBundleSubscriptionHandler}
        >
          {/* <h4 className="py-2">Plan Selection</h4> */}

          {/* <div className="form-group mx-from"> */}
          {/* <select
            className="form-control color mt-2"
            name="stationName_id"
            value={state.stationName_id}
            onChange={selectChangeHandler}
            id="stationName"
          >
            <option value="" disabled>
              Select Station Name
            </option>
            {stationNameList.map((stationName, index) => (
              <option key={index} value={stationName.ev_charging_site_id}>
                {stationName.name}
              </option>
            ))}
          </select> */}

          {/* code i commented according to new design */}
          {/* <select
            className="form-control color mt-2 text-center"
            name="plan"
            value={state.plan}
            onChange={selectChangeHandler}
            id="plan"
          >
            <option value="" selected disabled hidden>
              Plan Selection
            </option>
            {planSelectionNameList.map((planSelectionName, index) => {
              return (
                <option
                  key={index}
                  value={planSelectionName.bundle_subscription_type_code}
                >
                  {planSelectionName.name}  {`${planSelectionName.bundle_subscription_type_code === "ANYT" ? "900 SEK/month" : "300 SEK/month"}`}


                </option>
              );
            })}
          </select> */}

          {/* <select
                className="form-control color mt-2 text-center"
                name="dayReference"
                value={state.day_Reference}
                onChange={selectChangeHandler}
                id="dayReference"
              >
                <option value="" disabled>
                  Day Reference
                </option>
                {bundleDayReferenceList.map((bundleDayReference, index) => {
                    <option
                      key={index}
                      value={bundleDayReference.day_code}
                    >
                      {bundleDayReference.name}
                    </option>
                })}
              </select> */}
          {/* </div> */}

          {!planSelected
            ? planSelectionNameList
                .filter((item) => {
                  console.log("planSelectionNameList", item);
                  if (
                    item.bundle_subscription_type_code === "ANYT" && //Only s add at last ot ANYT
                    anytimeParkSlots
                  ) {
                    return;
                  } else {
                    return item;
                  }
                })
                .map((item, i) => {
                  return (
                    <div
                      key={item.bundle_subscription_type_code}
                      for={item.bundle_subscription_type_code}
                      onClick={(e) => {
                        console.log("div event :", item);
                        // setState({ field: "plan", value: item.bundle_subscription_type_code });
                        setObject({
                          field: "plan",
                          value: item.bundle_subscription_type_code,
                        });
                        // setSelectedPlan(item);
                      }}
                      className={`planSelection_list ${
                        selectedPlan?.bundle_subscription_type_code ===
                        item.bundle_subscription_type_code
                          ? "selectedPlan"
                          : null
                      }`}
                    >
                      <input
                        type="radio"
                        id={item.bundle_subscription_type_code}
                        name="radio-group"
                        onChange={() => setSelectedPlan(item)}
                      />
                      <label
                        for={item.bundle_subscription_type_code}
                        className="planName"
                      >
                        {item.name}
                      </label>
                      <p className="planPrice">
                        {/* {item.bundle_subscription_type_code === "ANYT" ? "900 SEK/month" : "300 SEK/month"} */}
                      </p>
                    </div>
                  );
                })
            : null}

          {!planSelected ? (
            <div className="notification_section">
              {/* {
                  selectedPlan?.name === "anytimeShare" || selectedPlan?.name === "dayShare" || selectedPlan?.name === "flexShare" ? (<p className="notification_heading">Notification to all users</p>) : null
                } */}

              <p className="notification_details">
                {/* <h5 className="nd_heading"> {selectedPlan?.name} </h5> */}

                {selectedPlan?.name === "noSHARE"
                  ? "With the noSHARE plan you can charge any day of the week.Electricity is paid for separately from the monthly subscription fee."
                  : selectedPlan?.name === "daySHARE"
                  ? "With the daySHARE plan you can charge anytime during the day you selected. In addition you can use the eluPASS to book 2 hour slots during other days in the week based on availability.Electricity is paid for separately from the monthly subscription fee."
                  : selectedPlan?.name === "flexSHARE"
                  ? "With the flexSHARE plan you can book timeslots up to 12 hours based on availability. Electricity is paid for separately from the monthly subscription fee."
                  : null}
              </p>

              {/* <p className="notification_details">

                  In addition to the above subscription fee,
                  a variable fee for energy and time will be charged to the credit card on file at the end of the month.
                </p>

                <p className="notification_details">
                  This variable fee will be clearly
                  displayed before you book. Prices may vary depending on time when the charging will occur.

                </p> */}
            </div>
          ) : null}

          <div className={` ${state.plan ? "" : "d-none"}`}>
            {!congratulationScreen && (
              <div className="bundle_details">
                <h2 className="selectedBundle_name"> {selectedPlan?.name} </h2>
              </div>
            )}

            <div className="form-group mx-from">
              {/* <div className="text-justify">
              {
                state.day_reference_code_ui && (
                  <i className="fa fa-chevron-left" onClick={() => {
                    setState({
                      field: "day_reference_code_ui",
                      value: false,
                    })
                    setState({ field: "parking_slot_id", value: "" });
                  }}></i>
                )
              }</div> */}

              {/* {bundleDayReferenceList.length > 0 && state.plan == "DAYSH" && (
              <select
                className="form-control color mt-2 text-center mb-2"
                name="day_reference_code"
                value={state.day_reference_code}
                onChange={selectChangeHandler}
                id="day_reference_code"
              >
                <option value="" disabled>
                  Day Reference
                </option>
                {bundleDayReferenceList.map((bundleDayReference, index) => (
                  <option key={index} value={bundleDayReference.day_code}>
                    {bundleDayReference.name}
                  </option>
                ))}
              </select>
            )} */}
              {congratulationScreen ? (
                <div style={{ textAlign: "start" }}>
                  <span
                    style={{ fontWeight: "700", textAlign: "center" }}
                    className="nd_heading"
                  >
                    Congratulations to your purchase of a{" "}
                    {dayReferenceChargingSiteBundleList[0]?.name} plan!​
                  </span>{" "}
                  <p style={{ marginTop: "20px" }}>
                    The following fees will be charged to your payment card on
                    file once a month unless the subscription is canceled:
                  </p>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ color: "#777" }}>Subscription Fee: </span>
                    <span style={{ fontWeight: "700" }} className="nd_heading">
                      {formatPrice(
                        dayReferenceChargingSiteBundleList[0]?.price
                      ) || "0.00"}{" "}
                      {dayReferenceChargingSiteBundleList[0]?.currency_code}
                      {dayReferenceChargingSiteBundleList[0]
                        ?.bundle_duration_type_code === "M"
                        ? "/month"
                        : "/week"}
                    </span>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ color: "#777" }}>Electricity Fee:​ </span>
                    <span style={{ fontWeight: "700" }} className="nd_heading">
                      {formatPrice(
                        dayReferenceChargingSiteBundleList[0]?.chargeItemKWH
                          ?.charge_item_price?.price
                      ) || "0.00"}{" "}
                      {dayReferenceChargingSiteBundleList[0]?.currency_code}/kWh
                    </span>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ color: "#777" }}>EV spot fee: ​ </span>
                    <span style={{ fontWeight: "700" }} className="nd_heading">
                      {formatPrice(
                        dayReferenceChargingSiteBundleList[0]?.chargeItemSpotFee
                          ?.charge_item_price?.price
                      ) || "0.00"}{" "}
                      {dayReferenceChargingSiteBundleList[0]?.currency_code}
                      /hour
                    </span>
                  </div>
                </div>
              ) : bothShare && dayReferenceChargingSiteBundleList[0] ? (
                <div style={{ textAlign: "start" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "-1rem",
                    }}
                  >
                    <p>Subscription: </p>
                    <p style={{ fontWeight: "700" }} className="nd_heading">
                      {" "}
                      {formatPrice(
                        dayReferenceChargingSiteBundleList[0]?.price
                      ) || "0.00"}
                      {dayReferenceChargingSiteBundleList[0]?.currency_code}
                      {dayReferenceChargingSiteBundleList[0]
                        ?.bundle_duration_type_code === "M"
                        ? "/month"
                        : "/week"}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "-1rem",
                    }}
                  >
                    <p>Electricity usage: </p>
                    <p style={{ fontWeight: "700" }} className="nd_heading">
                      {" "}
                      {formatPrice(
                        dayReferenceChargingSiteBundleList[0]?.chargeItemKWH
                          ?.charge_item_price?.price
                      ) || "0.00"}{" "}
                      {dayReferenceChargingSiteBundleList[0]?.currency_code}/kWh
                    </p>{" "}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "-1rem",
                    }}
                  >
                    <p>EV spot fee: </p>
                    <p style={{ fontWeight: "700" }} className="nd_heading">
                      {formatPrice(
                        dayReferenceChargingSiteBundleList[0]?.chargeItemSpotFee
                          ?.charge_item_price?.price
                      ) || "0.00"}{" "}
                      {dayReferenceChargingSiteBundleList[0]?.currency_code}
                      /hour
                    </p>{" "}
                  </div>

                  <p
                    style={{
                      fontStyle: "italic",
                      textAlign: "center",
                      marginTop: "15px",
                    }}
                  >
                    Above prices are subject to change.​
                  </p>
                  <p
                    style={{ fontStyle: "normal" }}
                    className="notification_details"
                  >
                    {selectedPlan?.name === "noSHARE" ? (
                      "With the noSHARE plan you can charge any time, any day of the week. The EV spot is yours 24/7. Electricity is included in noSHARE subscription fee."
                    ) : selectedPlan?.name === "daySHARE" ? (
                      <>
                        <p style={{ display: "none" }}>
                          The{" "}
                          <span
                            style={{ fontWeight: "700" }}
                            className="nd_heading"
                          >
                            {selectedPlan?.name}
                          </span>{" "}
                          plan pre-books a defined day each week in addition to
                          allowing eluPASS bookings for charging in{" "}
                          <span
                            style={{
                              color: "darkblue",
                              textDecoration: "underline",
                            }}
                            onClick={() => history.push("/my_schedule")}
                          >
                            My Calender
                          </span>{" "}
                        </p>
                      </>
                    ) : selectedPlan?.name === "flexSHARE" ||
                      selectedPlan?.name === "noSHARE" ? (
                      <>
                        <p style={{ display: "none" }}>
                          The{" "}
                          <span
                            style={{ fontWeight: "700" }}
                            className="nd_heading"
                          >
                            {selectedPlan?.name}
                          </span>{" "}
                          flexSHARE plan allows users to book time slots for
                          charging in{" "}
                          <span
                            style={{
                              color: "darkblue",
                              textDecoration: "underline",
                            }}
                            onClick={() => history.push("/my_schedule")}
                          >
                            My Calender
                          </span>{" "}
                        </p>
                      </>
                    ) : null}
                  </p>
                </div>
              ) : !isLoading && !bothShare ? (
                (bundleDayReferenceList.length > 0 && state.plan == "DAYSH") ||
                (bundleDayReferenceList.length > 0 && state.plan == "ANYT") ? (
                  bundleDayReferenceList.map((dayRef, index) => (
                    <div className="parking_days_main">
                      {chargingSlots?.length &&
                      chargingSlots?.some(
                        (obj) =>
                          obj.day?.toLowerCase() ===
                            dayRef.name.toLowerCase() &&
                          obj.parkingSlots?.length
                      ) ? (
                        <>
                          <div className="days_list" key={index}>
                            <div className="">
                              <Switch
                                // id={dayRef.day_code}
                                value={dayRef.day_code}
                                onChange={switchChangeHandlerDayShare}
                                // onChange={
                                //   (e) => setDaySelected({
                                //     field: "day_reference_code",
                                //     value: e.target.id
                                //   })
                                // }

                                selected={state.day_reference_code}
                                // selected={daySelected?.value}
                              />
                            </div>
                            <div className="day_name">
                              <label>{dayRef.name}</label>
                            </div>
                            <div className="day_price">
                              {dayBundles.some(
                                (bundle) =>
                                  bundle?.day?.toLowerCase() ===
                                  dayRef?.name?.toLowerCase()
                              )
                                ? `${
                                    dayBundles.find(
                                      (bundle) =>
                                        bundle?.day?.toLowerCase() ===
                                        dayRef?.name?.toLowerCase()
                                    )?.price
                                  } ${
                                    dayBundles.find(
                                      (bundle) =>
                                        bundle?.day?.toLowerCase() ===
                                        dayRef?.name?.toLowerCase()
                                    )?.currency
                                  }`
                                : `0 SEK`}
                              {/* {`${ps.price} ${ps.currency_code}`} */}
                            </div>
                          </div>

                          <>
                            {parkingSlotsList[0]?.day_code ===
                            dayRef.day_code ? (
                              <div className=" charging_slots_main form-group mx-from">
                                {parkingSlotsList.map((ps, index) => (
                                  <div className="c_slot" key={index}>
                                    <div className="">
                                      <Switch
                                        isSmall={true}
                                        onChange={onParkingSlotChecked}
                                        value={ps.parking_slot_id}
                                        selected={state.parking_slot_id}
                                      />
                                    </div>
                                    <div className="c_label">
                                      <label>{ps.parking_number}</label>
                                    </div>

                                    <div className="c_price">
                                      {/* {`${ps.price} ${ps.currency_code}`} */}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : null}
                          </>
                        </>
                      ) : (
                        <>
                          {parkingSlotsList[0]?.day_code === dayRef.day_code ? (
                            <div className=" charging_slots_main form-group mx-from">
                              {parkingSlotsList.map((ps, index) => (
                                <div className="c_slot" key={index}>
                                  <div className="">
                                    <Switch
                                      isSmall={true}
                                      onChange={onParkingSlotChecked}
                                      value={ps.parking_slot_id}
                                      selected={state.parking_slot_id}
                                    />
                                  </div>
                                  <div className="c_label">
                                    <label>{ps.parking_number}</label>
                                  </div>

                                  <div className="c_price">
                                    {/* {`${ps.price} ${ps.currency_code}`} */}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : null}
                        </>
                      )}
                    </div>
                  ))
                ) : (
                  <div>
                    {parkingSlotsList.map((ps, index) => (
                      <div className="c_slot" key={index}>
                        <div className="">
                          <Switch
                            isSmall={true}
                            onChange={onParkingSlotChecked}
                            value={ps.parking_slot_id}
                            selected={state.parking_slot_id}
                          />
                        </div>
                        <div className="c_label">
                          <label>{ps.parking_number}</label>
                        </div>

                        <div className="c_price">
                          {`${ps.price} ${ps.currency_code}`}
                        </div>
                      </div>
                    ))}
                  </div>
                )
              ) : (
                <Loading style={{ height: "30px" }} />
              )}
              {/* {dayReferenceChargingSiteBundleList.length > 0 &&
              state.plan == "DAYSH" && (
                <select
                  className="form-control color mt-2 mb-2"
                  name="day_reference_charging_site_bundle"
                  value={state.day_reference_charging_site_bundle}
                  onChange={selectChangeHandler}
                  id="day_reference_charging_site_bundle"
                >
                  {dayReferenceChargingSiteBundleList.map(
                    (dayReferenceChargingSiteBundle, index) => (
                      <option
                        key={index}
                        value={
                          dayReferenceChargingSiteBundle.ev_charging_site_bundle_id
                        }
                        selected={
                          state.day_reference_charging_site_bundle ==
                          dayReferenceChargingSiteBundle.ev_charging_site_bundle_id
                        }
                      >
                        {dayReferenceChargingSiteBundle.name}
                      </option>
                    )
                  )}
                </select>
              )} */}

              {/* ................................. */}
              {/* {
              dayReferenceChargingSiteBundleList.map((dayReferenceChargingSiteBundle, index) => (
                <div className="card mb-3 card-style" key={index}>
                  <div className="card-body">
                    <h4 className="card-text">
                      {dayReferenceChargingSiteBundle.name}
                    </h4>
                  </div>
                </div>
              ))
            } */}
              {/* .................................. */}
              {planStationBundleList.length > 0 &&
                state.ev_charging_site_bundle_id && (
                  <div>
                    {/* {state.plan != "DAYSH" && (
                    <select
                      className="form-control color mt-2 mb-2"
                      name="ev_charging_site_bundle_id"
                      value={state.ev_charging_site_bundle_id}
                      onChange={selectChangeHandler}
                      id="ev_charging_site_bundle_id"
                    >
                      <option value="" disabled>
                        {state.plan == "ANYT"
                          ? "Select Plans"
                          : "Show Available days"}
                      </option>
                      {planStationBundleList.map((planStation, index) => (
                        <option
                          key={index}
                          value={planStation.ev_charging_site_bundle_id}
                          selected={
                            state.ev_charging_site_bundle_id ==
                            planStation.ev_charging_site_bundle_id
                          }
                        >
                          {planStation.name}
                        </option>
                      ))}
                    </select>
                  )}

                  <div className="card mb-3 card-style">
                    <div className="card-body">
                      <p className="card-text">
                        {ChargingSiteBundleInfo.description}
                      </p>
                      <p className="h6">
                        {ChargingSiteBundleInfo.bundleFixedPriceCharged}{" "}
                        {ChargingSiteBundleInfo.currency}
                      </p>
                    </div>
                  </div> */}

                    {/* ........................ */}

                    {/* {planStationBundleList.map((planStation, index) => (
                    <div className="card mb-3 card-style" key={index}>
                      <div className="card-body">
                        <h1 className="card-text">
                          {planStation.name}
                        </h1>
                        <p className="h6">
                          {ChargingSiteBundleInfo.bundleFixedPriceCharged}{" "}
                          {ChargingSiteBundleInfo.currency}
                        </p>
                      </div>
                    </div>
                  ))
                  } */}
                  </div>
                )}

              {/* .......................... */}
              {/* {parkingSlotsList.map((ps, index) => (
              <div key={index}>
                <div className="row parking-slots-list">
                  <div className="col-2">
                    <Switch
                      onChange={onParkingSlotChecked}
                      value={ps.parking_slot_id}
                      selected={state.parking_slot_id}
                    />
                  </div>
                  <div className="col-4">
                    <label>{ps.parking_number}</label>
                  </div>

                  <div className="col-6 float-right">
                    {`${ps.price} ${ps.currency_code}`}
                  </div>
                </div>
              </div>
            ))} */}
            </div>
          </div>
          {/* {
          dayReferenceChargingSiteBundleList.length > 0 &&
          state.day_reference_charging_site_bundle &&
          parkingSlotsList.length < 1 && (
            <div class="alert alert-warning" role="alert">
              No parking slot Found
            </div>
          )
        } */}

          {/* <button
          className="button btn btn-primary form-control color mt-2 "
          type="submit"
          disabled={submitPlan || parkingSlotsList.length < 1}
        >
          {submitPlan ? <Loading style={{ height: "30px" }} /> : "Save"}
        </button> */}

          {/* ................................ */}
          {/* {
          planSelected ?
            <button
              className="button btn btn-primary form-control color mt-2 "
              type="submit"
              disabled={submitPlan || parkingSlotsList.length < 1}
            >


              {dayReferenceChargingSiteBundleList.length === 0 ? "Confirm" :
                submitPlan ? <Loading style={{ height: "30px" }} /> : "Buy"}
            </button> : <button
              className="button btn btn-primary form-control color mt-2 "
              // disabled={submitPlan || parkingSlotsList.length < 1}

              onClick={() => (handleSavePlan()
              )}
            >
              Select Plan
            </button>
        } */}

          {!congratulationScreen && renderButton()}
        </form>
      ) : (
        <div className="Loader_div">
          <Loading style={{ height: "30px" }} />
        </div>
      )}
      <Modal
        show={stationInactiveModal}
        onHide={() => {
          setstationInactiveModal(false);
          window.location.reload();
        }}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Plan Selection</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please wait for your account activation!</Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-dark"
            onClick={() => {
              setstationInactiveModal(false);
              window.location.reload();
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PlanSelection;

// Check if bundle_subscription_type_code is "FLEX" or "ANYT"
